// 导入组件，组件必须声明 name
import Vue from "vue";
import { DatePicker, RadioGroup, Radio, TimePicker, Button, Table, TableColumn } from 'element-ui';
import "./style/common.css";

Vue.component(DatePicker.name, DatePicker);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(Radio.name, Radio);
Vue.component(TimePicker.name, TimePicker);
Vue.component(Button.name, Button);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);

import videoPreviewExpand from "./src/videoPreviewExpand.vue";

videoPreviewExpand.install = function(Vue) {
  Vue.component(videoPreviewExpand.name, videoPreviewExpand);
};

export default videoPreviewExpand;
